class Bet {

	static title () {
		return 'Bet';
	}

	static selectors () {
		return [];
	}

	static permutations (selections, box = false) {
		return 0;
	}

	static enableBox () {
		return true;
	}

}

export default Bet;



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/gambling-calculator/bets/Bet.js
 **/